import { useContext, memo } from 'react';
import { Bar, Chart } from 'react-chartjs-2';
import type { ChartData, ChartOptions } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import {
  generationChartOption,
  generationChartData
} from './annualGenerationChartData';
import { AllInputDataContext, CalculatedDataContext } from '../../../config';
import styles from './../AllCharts.module.css';
import styles2 from '../DayChart/DayChart.module.css';
Chart.register(annotationPlugin);

type ToolTipProps = {
  name: string;
  description: string;
  color?: string;
};

const ToolTip = memo(({ name, description }: ToolTipProps) => {
  return (
    <div className={styles2.chartsTooltip}>
      <FontAwesomeIcon icon={faInfoCircle} className={styles2.chartsInfoIcon} />
      <span className={styles2.chartsTooltiptext}>
        <p>
          <b>{name}</b>
          <br />
          {description}
        </p>
      </span>
    </div>
  );
});

const AnnualGenerationChart = memo(() => {
  const allInputData = useContext(AllInputDataContext);
  const { annualConst } = useContext(CalculatedDataContext);

  const chartData = generationChartData({ annualConst, allInputData });
  const chartOptions = generationChartOption({ annualConst });

  return (
    <div className={styles.dataChart}>
      <div className={styles.chartInnerCard}>
        <ToolTip
          name='Curtailment'
          description={`Annual Curtailment: ${annualConst.curtailment} TWh`}
          color='black'
        />
        {/* Narrow the generic helper return to the bar chart at the boundary. */}
        <Bar
          data={chartData as ChartData<'bar'>}
          options={chartOptions as ChartOptions<'bar'>}
        />
      </div>
    </div>
  );
});
export default AnnualGenerationChart;
